import React from "react";
import { DataTableContext } from "./data-table-context";
import { useDataTableHook } from "./data-table-hooks";
import { DataTableType } from "../types/index";

export function ContextDataTableProvider<RecordType, FilterValueType>({
  children,
  ...props
}: {
  children: React.ReactNode;
} & DataTableType<RecordType, FilterValueType>) {
  if (!props.controller) {
    throw new Error("DataTable must be used within a controller");
  }

  const value = useDataTableHook<RecordType, FilterValueType>(props);

  return (
    <DataTableContext.Provider value={value}>
      {children}
    </DataTableContext.Provider>
  );
}
